<script lang="ts">
    import { onMount } from 'svelte'
    import DateSelect from '../../_common/date-select.svelte'
    import { GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import type { Appointment } from '../../../modules/schedulerApi/appointments/appointment'
    import { AppointmentStatus, AppointmentStatusFriendly } from '../../../modules/schedulerApi/appointments/appointments.enum'
    import type { Schedule } from '../../../modules/schedulerApi/schedules/schedule'
    import LoadSpinner from '../../_common/load-spinner.svelte'

    // só os status com rótulo amigável entram como coluna — excluído/bloqueado/disponível não representam um atendimento real
    const STATUS_ORDER = Object.keys(AppointmentStatusFriendly) as AppointmentStatus[]
    // rótulos curtos pra caber no cabeçalho da coluna (o resto vem de AppointmentStatusFriendly)
    const STATUS_LABELS: Record<string, string> = {
        ...AppointmentStatusFriendly,
        agendamento_cancelado_usuario: 'Cancelado cli',
        agendamento_cancelado_empresa: 'Cancelado empr.',
        agendamento_remarcado: 'Remarcado não desc.',
        agendamento_remarcado_descontar: 'Remarcado desc.',
    }

    interface ScheduleRow {
        name: string
        counts: Record<string, number>
        total: number
    }

    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.today()

    onMount(() => {
        load(dateSelect.from, dateSelect.to)
    })

    let show = false
    let grid: GridClass = null

    async function load(from: Date, to: Date) {
        if (show) return
        show = true
        let data: Appointment[] = await window.api.schedulers.appointments.getAll({ from, to })
        data = data.filter((a) => STATUS_ORDER.includes(a.status))
        const schedules: Schedule[] = await window.api.schedulers.schedules.getAll({ all: true, slots: false }, 600)
        for (const appointment of data) {
            appointment.schedule = schedules.find((el) => el.scheduleId === appointment.scheduleId)
        }
        console.log('relat.data', data)
        loadGrid(data)
        show = false
    }

    function loadGrid(data: Appointment[]) {
        const grouped = new Map<string, ScheduleRow>()
        for (const appointment of data) {
            const key = appointment.scheduleId || '-'
            let acc = grouped.get(key)
            if (!acc) {
                acc = { name: appointment.schedule?.label || '[sem agenda]', counts: {}, total: 0 }
                grouped.set(key, acc)
            }
            acc.counts[appointment.status] = (acc.counts[appointment.status] || 0) + 1
            acc.total++
        }

        grid = new GridClass()
        grid.title = 'Atendimentos por agenda'
        grid.showFilter = false
        grid.cols.push(new GridCol({ content: 'Agenda' }))
        for (const status of STATUS_ORDER) {
            grid.cols.push(new GridCol({ content: STATUS_LABELS[status], type: GridColTypeEnum.int, showTotal: true }))
        }
        grid.cols.push(new GridCol({ content: 'Total', type: GridColTypeEnum.int, showTotal: true }))

        const rows = [...grouped.values()].filter((row) => row.total !== 0).sort((a, b) => a.name.localeCompare(b.name))
        for (const row of rows) {
            let line: GridLine = new GridLine()
            line.slots.push({ content: row.name })
            for (const status of STATUS_ORDER) {
                line.slots.push({ content: row.counts[status] || 0 })
            }
            line.slots.push({ content: row.total })
            grid.lines.push(line)
        }
        console.log('relat.grid', grid)
        grid = grid
    }

    function dateChanged(event) {
        dateSelect = event.detail
        load(dateSelect.from, dateSelect.to)
    }
</script>

<div class="relat-body">
    <div class="acts h-print">
        <div class="date">
            <DateSelect on:change={dateChanged} />
        </div>
    </div>
    <div class="grid mt-2">
        <Grid {grid} />
    </div>
</div>
<LoadSpinner {show}></LoadSpinner>
